import { useQuery } from '@tanstack/react-query';
import queryString from 'query-string';

import { $api } from 'modules/global';

export function useTotalXp(ticketId?: string) {
  const { data, isLoading, ...args } = useQuery<number>({
    queryKey: ['total-xp', ticketId],
    queryFn: async () => {
      const { data } = await $api.get(
        queryString.stringifyUrl({
          url: '/check-test',
          query: { ticket_id: ticketId }
        })
      );

      return data;
    },
    enabled: !!ticketId
  });

  return { totalXp: data, isLoadingXp: isLoading, ...args };
}
